import logo from './assets/sam.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Samwise Kazerouni
        </p>
      </header>
    </div>
  );
}

export default App;
